class FormErrorShower {
  constructor() {
    const el = $('form .error').first();

    if (el.length > 0) {
      let offset = el.offset().top;

      if (el.hasClass('form-error-container')) {
        offset = el.offset().top - 200;
      }

      $('html, body').animate(
        {
          scrollTop: offset
        },
        500
      );
    }
  }
}

export default FormErrorShower;



// WEBPACK FOOTER //
// ./src/javascripts/FormErrorShower.js